










































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Ref } from 'vue-property-decorator';
import MarkdownRenderer from '@/pages/shop/components/MarkdownRenderer.vue';

@Component({
    components: { MarkdownRenderer },
})
export default class EventDescription extends Vue {
    @Prop({ required: true }) description!: string | null;
    @Ref('contentBox') readonly contentBox!: HTMLDivElement;
    @Ref('innerContentBox') readonly innerContentBox!: Vue;

    private innerContentObserver: ResizeObserver | null = null;

    collapsed = true;
    expandedHeight = 0;

    get containerStyle() {
        if (this.collapsed && this.hasMore) {
            return { height: `${this.collapsedHeight}px` };
        }

        // When expanded, use the measured scrollHeight
        return {
            height: this.expandedHeight ? `${this.expandedHeight}px` : 'auto',
        };
    }

    get collapsedHeight(): number {
        return Math.min(this.expandedHeight, 200); // 12.5rem @ 16px base
    }

    get hasMore(): boolean {
        return this.expandedHeight > this.collapsedHeight;
    }

    get descriptionString(): string {
        return this.description || '';
    }

    get showDescription(): boolean {
        return !!this.descriptionString.trim().length;
    }

    mounted(): void {
        if (!this.contentBox) {
            return;
        }

        // Image load changes the content height, recalculate after load.
        for (const imgEl of this.contentBox.getElementsByTagName('img')) {
            imgEl.addEventListener('load', this.recalculateExpandedHeight, {
                once: true,
            });
        }

        this.initObserver();
        this.recalculateExpandedHeight();
    }

    beforeDestroy(): void {
        if (this.innerContentObserver) {
            this.innerContentObserver.disconnect();
        }
    }

    recalculateExpandedHeight() {
        this.$nextTick(() => {
            this.expandedHeight = this.contentBox?.scrollHeight || 0;
        });
    }

    toggleCollapse() {
        if (this.collapsed) {
            // Measure the height of the content box right before expanding it.
            this.recalculateExpandedHeight();
        }

        this.collapsed = !this.collapsed;
    }

    initObserver(): void {
        if (!this.innerContentBox) {
            return;
        }

        this.innerContentObserver = new ResizeObserver(() => {
            this.recalculateExpandedHeight();
        });

        this.innerContentObserver.observe(this.innerContentBox.$el);
    }
}
